import { useContext } from 'react';
import MapContext from '../contexts/MapContext';

const useMapContext = () => useContext(MapContext);

export default useMapContext;
